module.exports = __webpack_public_path__ + "static/media/erca_logo.53e74f9b.jpg";